"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[822],{

/***/ 9432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8382);




function Footer(param) {
    let { company  } = param;
    const [businessHours, setBusinessHours] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const fetchBusinessHours = async ()=>{
            const hours = [];
            try {
                const res = await (0,_services_api__WEBPACK_IMPORTED_MODULE_3__/* .fetchGetCompanyBusinessHours */ .Ez)();
                if (res.monday && res.tuesday && res.wednesday && res.thursday && res.friday) {
                    const sameWeekdayHours = res.mondayOpeningTime === res.tuesdayOpeningTime && res.mondayOpeningTime === res.wednesdayOpeningTime && res.mondayOpeningTime === res.thursdayOpeningTime && res.mondayOpeningTime === res.fridayOpeningTime && res.mondayClosingTime === res.tuesdayClosingTime && res.mondayClosingTime === res.wednesdayClosingTime && res.mondayClosingTime === res.thursdayClosingTime && res.mondayClosingTime === res.fridayClosingTime;
                    if (sameWeekdayHours) {
                        hours.push({
                            name: "Segunda \xe0 Sexta",
                            openingTime: res.mondayOpeningTime.slice(0, 5),
                            closingTime: res.mondayClosingTime.slice(0, 5)
                        });
                    } else {
                        if (res.monday) {
                            hours.push({
                                name: "Segunda-feira",
                                openingTime: res.mondayOpeningTime.slice(0, 5),
                                closingTime: res.mondayClosingTime.slice(0, 5)
                            });
                        }
                        if (res.tuesday) {
                            hours.push({
                                name: "Ter\xe7a-feira",
                                openingTime: res.tuesdayOpeningTime.slice(0, 5),
                                closingTime: res.tuesdayClosingTime.slice(0, 5)
                            });
                        }
                        if (res.wednesday) {
                            hours.push({
                                name: "Quarta-feira",
                                openingTime: res.wednesdayOpeningTime.slice(0, 5),
                                closingTime: res.wednesdayClosingTime.slice(0, 5)
                            });
                        }
                        if (res.thursday) {
                            hours.push({
                                name: "Quinta-feira",
                                openingTime: res.thursdayOpeningTime.slice(0, 5),
                                closingTime: res.thursdayClosingTime.slice(0, 5)
                            });
                        }
                        if (res.friday) {
                            hours.push({
                                name: "Sexta-feira",
                                openingTime: res.fridayOpeningTime.slice(0, 5),
                                closingTime: res.fridayClosingTime.slice(0, 5)
                            });
                        }
                    }
                }
                if (res.saturday) {
                    hours.push({
                        name: "S\xe1bado",
                        openingTime: res.saturdayOpeningTime.slice(0, 5),
                        closingTime: res.saturdayClosingTime.slice(0, 5)
                    });
                }
                if (res.sunday) {
                    hours.push({
                        name: "Domingo",
                        openingTime: res.sundayOpeningTime.slice(0, 5),
                        closingTime: res.sundayClosingTime.slice(0, 5)
                    });
                }
                if (res.holiday) {
                    hours.push({
                        name: "Feriado",
                        openingTime: res.holidayOpeningTime.slice(0, 5),
                        closingTime: res.holidayClosingTime.slice(0, 5)
                    });
                }
                setBusinessHours(hours);
            } catch (error) {
                console.error("Erro ao buscar os hor\xe1rios de funcionamento:", error);
            }
        };
        fetchBusinessHours();
    }, []);
    const [activePages, setActivePages] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const pages = [];
        (0,_services_api__WEBPACK_IMPORTED_MODULE_3__/* .fetchGetCompanySiteSettings */ .XQ)().then((res)=>{
            res.showNew === true ? pages.push({
                route: "novos",
                name: "0 Km"
            }) : null;
            res.showUsed === true ? pages.push({
                route: "seminovos",
                name: "Seminovos"
            }) : null;
            res.showArmored === true ? pages.push({
                route: "blindados",
                name: "Blindados"
            }) : null;
            res.showFinancing === true ? pages.push({
                route: "financiamento",
                name: "Financiamento"
            }) : null;
            res.showVehiclePurchase === true ? pages.push({
                route: "venda-seu-veiculo",
                name: "Venda seu Ve\xedculo"
            }) : null;
            res.showInsurance === true ? pages.push({
                route: "seguro",
                name: "Seguro"
            }) : null;
            setActivePages(pages);
        });
    }, []);
    const formatPhone = (phone)=>{
        if (!phone) return null;
        if (phone.length === 10) {
            return "(".concat(phone.substring(0, 2), ") ").concat(phone.substring(2, 6), "-").concat(phone.substring(6, 10));
        }
        if (phone.length === 11) {
            return "(".concat(phone.substring(0, 2), ") ").concat(phone.substring(2, 7), "-").concat(phone.substring(7, 11));
        }
        return phone;
    };
    const cnpjMask = (number)=>{
        number.replace(/\D/g, "");
        return number.replace(/^(\d{2})(\d{3})?(\d{3})?(\d{4})?(\d{2})?/, "$1. $2. $3/$4-$5");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
            className: "footer-section",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "footer-wrapper pt-120 position-relative z-1 overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                        src: "/img/shapes/texture-bg.png",
                        alt: "rodape",
                        style: {
                            zIndex: -1
                        },
                        fill: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row justify-content-between",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-xl-5 col-lg-5",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "footer-widget widget-basic",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                className: "widget-title-large mb-4 text-white",
                                                children: "Tem alguma d\xfavida? Fale conosco e te ajudamos..."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-40",
                                                children: "Nossos vendedores possuem anos de experi\xeancia para tirar todas suas d\xfavidas e te dar o melhor atendimento do Brasil."
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "phone-box d-flex align-items-start flex-direction-column gap-3",
                                                children: [
                                                    company.phone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "flaticon-phone-call"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: "tel:+55".concat(company.phone),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                        className: "text-white ms-3 mb-0",
                                                                        children: formatPhone(company.phone)
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    company.phone2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "d-flex align-items-center",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                className: "icon-wrapper d-inline-flex align-items-center justify-content-center rounded-circle bg-primary text-white",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "flaticon-phone-call"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: "tel:+55".concat(company.phone2),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                                        className: "text-white ms-3 mb-0",
                                                                        children: formatPhone(company.phone2)
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                            className: "text-white",
                                                            children: [
                                                                "CNPJ : ",
                                                                cnpjMask(company.cnpj)
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-xl-7 col-lg-7",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "ms-lg-5 ms-xl-0 mt-5 mt-lg-0",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "row mt-30",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-sm-3",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "footer-widget footer-nav-widget mb-5 mb-sm-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "widget-title text-white mb-3 h6",
                                                                children: "Sobre N\xf3s"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                                className: "footer-nav",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "/sobre-nos",
                                                                            children: "Sobre"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "/contato",
                                                                            children: "Contato"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "col-sm-3",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "footer-widget footer-nav-widget mb-5 mb-sm-0",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "widget-title text-white mb-3 h6",
                                                                children: "Links R\xe1pidos"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                className: "footer-nav",
                                                                children: activePages.map((page, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: "/".concat(page.route),
                                                                            children: page.name
                                                                        })
                                                                    }, index))
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "col-sm-2 mb-5",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "text-white h6",
                                                            children: "Siga-nos"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                                            className: "footer-social-list",
                                                            children: [
                                                                company.youtube ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        className: "text-white",
                                                                        href: company.youtube,
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        "aria-label": "Acesse o youtube da nossa loja",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "fab fa-youtube"
                                                                        })
                                                                    })
                                                                }) : null,
                                                                company.facebook ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        className: "text-white",
                                                                        href: company.facebook,
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        "aria-label": "Acesse o facebook da nossa loja",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "fab fa-facebook-f"
                                                                        })
                                                                    })
                                                                }) : null,
                                                                company.instagram ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        className: "text-white",
                                                                        href: company.instagram,
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        "aria-label": "Acesse o instagram da nossa loja",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "fab fa-instagram"
                                                                        })
                                                                    })
                                                                }) : null,
                                                                company.tiktok ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        className: "text-white",
                                                                        href: company.tiktok,
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        "aria-label": "Acesse o tiktok da nossa loja",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                            className: "fab fa-tiktok"
                                                                        })
                                                                    })
                                                                }) : null
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "col-sm-4",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "widget-title text-white mb-3 h6",
                                                            children: "Hor\xe1rio de Funcionamento"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "footer-social d-inline-block text-start",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                                className: "footer-nav",
                                                                children: businessHours.map((hour, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                        style: {
                                                                            fontSize: "14px",
                                                                            color: "#FFFBFB"
                                                                        },
                                                                        children: [
                                                                            hour.name,
                                                                            " : ",
                                                                            hour.openingTime,
                                                                            " - ",
                                                                            hour.closingTime
                                                                        ]
                                                                    }, index))
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "footer-copyright",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "row align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-sm-7",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "copyright-text",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                className: "mb-0",
                                                children: [
                                                    "\xa9 Todos os direitos reservados. Desenvolvido por \xa0\xa0",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        href: "https://bndv.com.br",
                                                        target: "_blank",
                                                        rel: "noreferrer",
                                                        children: "BNDV - Banco Nacional de Ve\xedculos"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-sm-5",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "copyright-links text-start text-sm-end mt-1 mt-sm-0",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "/termos",
                                                children: "Termo de Uso e Pol\xedtica de Privacidade"
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 392:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _services_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8382);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);




function Header(param) {
    let { company  } = param;
    const [activePages, setActivePages] = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)([]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        const pages = [];
        (0,_services_api__WEBPACK_IMPORTED_MODULE_2__/* .fetchGetCompanySiteSettings */ .XQ)().then((res)=>{
            pages.push({
                route: "",
                name: "Home"
            });
            res.showNew === true ? pages.push({
                route: "novos",
                name: "0 Km"
            }) : null;
            res.showUsed === true ? pages.push({
                route: "seminovos",
                name: "Seminovos"
            }) : null;
            res.showArmored === true ? pages.push({
                route: "blindados",
                name: "Blindados"
            }) : null;
            pages.push({
                route: "sobre-nos",
                name: "Sobre"
            });
            res.showFinancing === true ? pages.push({
                route: "financiamento",
                name: "Financiamento"
            }) : null;
            res.showVehiclePurchase === true ? pages.push({
                route: "venda-seu-veiculo",
                name: "Venda seu Ve\xedculo"
            }) : null;
            res.showInsurance === true ? pages.push({
                route: "seguro",
                name: "Seguro"
            }) : null;
            pages.push({
                route: "contato",
                name: "Contato"
            });
            setActivePages(pages);
        });
    }, []);
    const formatPhone = (phone)=>{
        if (!phone) return null;
        if (phone.length === 10) {
            return "(".concat(phone.substring(0, 2), ") ").concat(phone.substring(2, 6), "-").concat(phone.substring(6, 10));
        }
        if (phone.length === 11) {
            return "(".concat(phone.substring(0, 2), ") ").concat(phone.substring(2, 7), "-").concat(phone.substring(7, 11));
        }
        return phone;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
                className: "header-style-one header-sticky",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "at_topbar d-none d-sm-block bg-white",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "row align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-xl-4 col-lg-5 col-8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tp-info",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mb-0",
                                                children: "".concat(company.nickName, " sua loja de confian\xe7a desde 2012 no Mercado.")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-xl-8 col-lg-7 col-4",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "tp-info-wrapper d-flex align-items-center justify-content-end",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "tp-info d-inline-flex align-items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "icon-wrapper me-2",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "flaticon-phone-call flaticonPlace"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "tel:+55".concat(company.phone),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "mb-0",
                                                                children: formatPhone(company.phone)
                                                            })
                                                        }),
                                                        company.phone2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "icon-wrapper me-2 ms-4 d-none d-xl-inline-flex",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                        className: "flaticon-phone-call flaticonPlace"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: "tel:+55".concat(company.phone2),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "mb-0",
                                                                        children: formatPhone(company.phone2)
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "tp-info d-inline-flex align-items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "icon-wrapper me-2",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "fa-brands fa-whatsapp flaticonPlace"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            target: "blank",
                                                            href: "https://api.whatsapp.com/send?phone=".concat(company.whatsapp, "&text=").concat(company.whatsappDefaultMessage ? company.whatsappDefaultMessage : "Ol\xe1, gostaria de tirar algumas d\xfavidas com um consultor. Algu\xe9m dispon\xedvel para me atender agora?"),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "mb-0",
                                                                children: company.whatsapp ? company.whatsapp.length === 10 ? "(".concat(company.whatsapp.substring(0, 2), ") ").concat(company.whatsapp.substring(2, 6), "-").concat(company.whatsapp.substring(6, 10)) : company.whatsapp.length === 11 ? "(".concat(company.whatsapp.substring(0, 2), ") ").concat(company.whatsapp.substring(2, 7), "-").concat(company.whatsapp.substring(7, 11)) : company.whatsapp : null
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "d-none tp-info d-xl-inline-flex align-items-center",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "icon-wrapper me-2",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                className: "flaticon-email flaticonPlace"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: "mailto:".concat(company.email),
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "mb-0",
                                                                children: company.email
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "at_header_nav",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "container",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "row align-items-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-6 col-lg-3",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "companyLogo",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "/",
                                                children: company.logo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    src: company.logo,
                                                    alt: "logo",
                                                    width: 180,
                                                    height: 72,
                                                    sizes: "100vw",
                                                    quality: 100,
                                                    loading: "lazy",
                                                    style: {
                                                        marginTop: "8px",
                                                        marginBottom: "8px"
                                                    }
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "col-6 col-lg-9",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "at_header_right d-flex align-items-center justify-content-end",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                                                    className: "at_nav_menu d-none d-lg-block",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                        children: activePages.map((page, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: "/".concat(page.route),
                                                                    children: page.name
                                                                })
                                                            }, index))
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                                    className: "mobile-menu-toggle header-toggle-btn ms-4 d-lg-none",
                                                    "aria-label": "Abrir Menu",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {}),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {})
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "mobile-menu position-fixed bg-white deep-shadow",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        className: "close-menu position-absolute",
                        "aria-label": "Fechar Menu",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                            className: "fa-solid fa-xmark"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: "/",
                        className: "logo-wrapper bg-secondary d-block mt-4 p-3 rounded-1 text-center",
                        children: company.logo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: company.logo,
                            alt: "logo",
                            width: 180,
                            height: 72,
                            sizes: "100vw",
                            quality: 100
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {})
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                        className: "mobile-menu-wrapper mt-20",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                            children: activePages.map((page, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: "/".concat(page.route),
                                        children: page.name
                                    })
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "contact-info mt-60",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                className: "mb-20",
                                children: "Contato"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "tel:+55".concat(company.phone),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: company.phone ? company.phone.length === 10 ? "(".concat(company.phone.substring(0, 2), ") ").concat(company.phone.substring(2, 6), "-").concat(company.phone.substring(6, 10)) : company.phone.length === 11 ? "(".concat(company.phone.substring(0, 2), ") ").concat(company.phone.substring(2, 7), "-").concat(company.phone.substring(7, 11)) : company.phone : null
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "mailto:".concat(company.email),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: company.email
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "social-contact",
                                children: [
                                    company.facebook ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: company.facebook,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "aria-label": "Acesse o facebook da nossa loja",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fab fa-facebook-f"
                                        })
                                    }) : null,
                                    company.instagram ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: company.instagram,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "aria-label": "Acesse o instagram da nossa loja",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fab fa-instagram"
                                        })
                                    }) : null,
                                    company.youtube ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: company.youtube,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "aria-label": "Acesse o youtube da nossa loja",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fab fa-youtube"
                                        })
                                    }) : null,
                                    company.tiktok ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        href: company.tiktok,
                                        target: "_blank",
                                        rel: "noreferrer",
                                        "aria-label": "Acesse o youtube da nossa loja",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                            className: "fab fa-tiktok"
                                        })
                                    }) : null
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ })

}]);